import React, { Component } from 'react';

export default class BasicCreateButton extends Component {
  static propTypes = {};

  render() {
    return (
      <button
        ref="submitButton"
        type="button"
        className="btn btn-default btn-primary"
        data-test="createButton"
        {...this.props}
      >
        {this.props.children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/BasicCreateButton/BasicCreateButton.js